import { PROJECT_VARIANTS } from '../../constants';
import * as aiStudioActions from '../../redux/ai-studio/aiStudioActions';

const aiStudioActionsMapping = {
  saveToBucket: {
    [PROJECT_VARIANTS.ADMIN]: aiStudioActions.saveToBucket,
    // [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerModifyConcept,
  },
  getFavoriteMedia: {
    [PROJECT_VARIANTS.ADMIN]: aiStudioActions.getFavoriteMedia,
    // [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerModifyConcept,
  },
  addToFavorites: {
    [PROJECT_VARIANTS.ADMIN]: aiStudioActions.addFavoriteMedia,
    // [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerModifyConcept,
  },
  saveFavoriteToBucket: {
    [PROJECT_VARIANTS.ADMIN]: aiStudioActions.saveFavoriteToBucket,
    // [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerModifyConcept,
  },
  removeFavoriteMedia: {
    [PROJECT_VARIANTS.ADMIN]: aiStudioActions.removeFavoriteMedia,
    // [PROJECT_VARIANTS.CONSUMER]: consumerId8Actions.consumerModifyConcept,
  },
  createNewBucket: {
    [PROJECT_VARIANTS.ADMIN]: aiStudioActions.createNewBucket,
  },
  createNewBucketFromFavorite: {
    [PROJECT_VARIANTS.ADMIN]: aiStudioActions.createNewBucketFromFavorite,
  },
  downloadFavoriteMediaBuffer: {
    [PROJECT_VARIANTS.ADMIN]: aiStudioActions.downloadFavoriteMediaBuffer,
    // [PROJECT_VARIANTS.CONSUMER]: consumerAiStudioActions.downloadConsumerFavoriteMediaBuffer,
  },
};

export default aiStudioActionsMapping;
